export const LIST = "list";
export const SUBLIST = "subList";
export const LISTITEM = "listItem";
export const DB_BASE_URI = "https://restaurant-manager-backend-production.up.railway.app";
export const DB_MAIN_CHECKLIST_ID = "631a5a8bd7104c31c1fb4fd3";